import * as React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createCompany } from '../../ApiUtils/ApiUtils';
import { stringToObjectKey } from '../../utils'

interface CompanyCreateFormProps {
    currentCompany?: string;
    handleClose: any;
    handleFormClose: any;
    submitErrors: any[];
}

interface CompanyCreateFormState {
    isLoading: boolean;
    submitErrors: any[];
}

class CompanyCreateForm extends React.Component<CompanyCreateFormProps, CompanyCreateFormState> {
    public constructor(props: CompanyCreateFormProps) {
        super(props);
        this.state = {
            isLoading: false,
            submitErrors: []
        };
    }

    public handleCreateSubmit = (item: any) => {
        item.preventDefault();
        this.setState({
            submitErrors: [],
            isLoading: true
        });


       /* if (item.target.elements.id.value === "") {
            this.setState({
                submitErrors: ["Company key required"],
                isLoading: false
            });
            return false;
        }*/

        if (item.target.elements.displayName.value === "") {
            this.setState({
                submitErrors: ["Company display name required"],
                isLoading: false
            });
            return false;
        }

        const data = {
            id: stringToObjectKey(item.target.elements.displayName.value),
            displayName: item.target.elements.displayName.value,
        };

        createCompany(data).then(response => {
            if (response === "") {
                this.props.handleFormClose();
                return;
            }

            try {
                const result = JSON.parse(response);
                const error = result.errorMessage || result.error;

                let friendlyError = "An unexpected error occurred.";

                if (error?.toLowerCase().includes("conflict")) {
                    friendlyError = "The company already exists. Please enter another name.";
                } else if (error) {
                    friendlyError = error;
                }

                this.setState({
                    submitErrors: [friendlyError],
                    isLoading: false
                });
            } catch (e) {
                console.error("Error parsing JSON:", e);
                this.setState({
                    submitErrors: ["An unexpected error occurred."],
                    isLoading: false
                });
            }
        });

        return false;
    };

    public render() {
        return (
            <>
                <Dialog
                    title={"Create new company"}
                    onClose={this.props.handleClose}
                    style={{ fontSize: "8px" }}
                    width={500}
                    height={"100%"}
                >
                    <div style={{ position: "relative" }}>
                        <div className="spinner-container" style={{ display: this.state.isLoading ? "block" : "none" }} >
                            {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />}
                        </div>
                        <form onSubmit={this.handleCreateSubmit} style={{ padding: "10px 15px 0px 15px" }}>

                            <label htmlFor="displayName">Display Name</label><br />
                            <input type="text" name="displayName" id="displayName" className="field k-input k-input-md k-rounded-md k-input-solid" required /><br />

                            <div style={{ color: "red", height: "50px", lineHeight: "50px" }}>{this.state.submitErrors}</div>

                            <input type="submit" value="Submit" className={"btn btn-primary user-create-button"} />
                            <button className={"btn btn-secondary user-create-button"} onClick={this.props.handleClose}>Cancel</button>
                        </form>
                    </div>
                </Dialog>
            </>
        );
    }
}

export default CompanyCreateForm;
